import React, { useEffect, useRef } from 'react';
import { Global } from '@emotion/core';
import styled from '@emotion/styled';
import { useColorMode } from 'theme-ui';

import NavigationFooter from '@components/Navigation/Navigation.Footer';
import NavigationHeader from '@components/Navigation/Navigation.Header';
import ArticlesContextProvider from '../../sections/articles/Articles.List.Context';

import { globalStyles } from '@styles';

/**
 * <Layout /> needs to wrap every page as it provides styles, navigation,
 * and the main structure of each page. Within Layout we have the <Container />
 * which hides a lot of the mess we need to create our Desktop and Mobile experiences.
 */
const Layout: React.FC<{}> = ({ children }) => {
  const [colorMode] = useColorMode();
  const scrolled = useRef(null)

  useEffect(() => {
    parent.postMessage({ theme: colorMode }, '*');
  }, [colorMode]);

  // Google Adsense
  useEffect(() => {
    const headID = document.getElementsByTagName('head')[0]

    document.addEventListener('scroll', function (e) {
        if (!scrolled.current) {
            scrolled.current = true

            // Google Ads
            const gaScript = document.createElement('script')
            gaScript.async = true
            gaScript.crossorigin = 'anonymous'
            gaScript['data-ad-client'] = 'ca-pub-7215147017121179'
            gaScript.src =
                'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js'
            gaScript.type = 'text/javascript'
            headID.appendChild(gaScript)
        }
    })
  }, [])

  return (
    <ArticlesContextProvider>
      <Container>
        <Global styles={globalStyles} />
        <NavigationHeader />
        {children}
        <NavigationFooter />
      </Container>
    </ArticlesContextProvider>
  );
}

export default Layout;

const Container = styled.div`
  position: relative;
  background: ${p => p.theme.colors.background};
  transition: ${p => p.theme.colorModeTransition};
  min-height: 100vh;
`;
